export default {
  "a_level": "NIVEL A",
  "a_link_will_be_sent_to_your_email_containing_the_information_you_need_for_your_password": "Se enviará un enlace a su correo electrónico con la información necesaria para su contraseña",
  "a_message_has_been_sent_to_your_email__kindly_follow_the_link_to_reset_your_password": "Se ha enviado un mensaje a su correo electrónico. Por favor, siga el enlace para restablecer su contraseña",
  "about_us": "Sobre nosotros",
  "academic_year": "Año académico",
  "account_detail": "Detalle de la cuenta",
  "account_email": "Correo de la cuenta",
  "account_name": "Nombre de la cuenta",
  "account_password": "Contraseña de la cuenta",
  "account_photo": "Foto de la cuenta",
  "account_status": "Estado de la cuenta",
  "account_type": "Tipo de cuenta",
  "account_username": "Nombre de usuario de la cuenta",
  "action": "Acción",

  "add_new__tabledisplaylabel": "Añadir nueva {Etiqueta de visualización de la tabla}",
  "add_new_administrators": "Añadir nuevos administradores",
  "add_new_app_config": "Añadir nueva configuración de la aplicación",
  "add_new_applicant_selected_grants": "Añadir nuevo solicitante Subvenciones seleccionadas",
  "add_new_applicants": "Añadir nuevos solicitantes",
  "add_new_audit_for_applicants": "Añadir nueva auditoría para los solicitantes",
  "add_new_caps_institutions_list": "Añadir nueva lista de instituciones CAPS",
  "add_new_caps_programmes_list": "Añadir nueva lista de programas CAPS",
  "add_new_institution_accounts": "Añadir nuevas cuentas de la institución",
  "add_new_institution_admissions_uploads": "Añadir nuevas cargas de admisión de la institución",
  "add_new_institution_campuses": "Añadir nuevos campus institucionales",
  "add_new_institution_programmes": "Añadir nuevos programas institucionales",
  "add_new_institution_schools": "Añadir nuevas escuelas institucionales",
  "add_new_payments": "Añadir nuevos pagos",
  "add_new_third_party_agencies": "Añadir nuevas agencias de terceros",
  "add_new_third_party_agencies_grants": "Añadir nuevas subvenciones de agencias de terceros",
  "additional_form_definition": "Definición de formulario adicional",
  "address_line_1": "Dirección Línea 1",
  "address_line_2": "Dirección Línea 2",
  "address_line_3": "Dirección Línea 3",
  "address_line_4": "Dirección Línea 4",
  "address_line1": "Dirección Línea1",
  "address_line2": "Dirección Línea2",
  "address_line3": "Dirección Línea3",
  "address_line4": "Dirección Línea4",
  "administrators": "Administradores",
  "administrators_details": "Datos de los administradores",
  "agency_name": "Nombre de la Agencia",
  "alive": "Vivo",
  "all_rights_reserved": "Todos los derechos reservados",
  "allow_email_alert": "Permitir alerta por correo electrónico",
  "allow_sms_alert": "Permitir alerta de Sms",
  "allow_two_factor_auth": "Autenticación de dos factores",
  "already_exist": " Ya existen.",
  "already_have_an_account": "Ya tiene una cuenta",
  "amount": "Monto",

  "app_config": "Configuración de la aplicación",
  "app_config_details": "Detalles de la configuración de la aplicación",
  "app_config_id": "ID. de configuración de la aplicación",
  "applicant_accepted_programme_id": "Solicitante Aceptado Programa ID",
  "applicant_id": "ID. del solicitante",
  "applicant_selected_grant_id": "Solicitante seleccionado ID de subvención",
  "applicant_selected_grants": "Subvenciones seleccionadas por los solicitantes",
  "applicant_selected_grants_details": "Detalles de las subvenciones seleccionadas por el solicitante",
  "applicants": "Solicitantes",
  "applicants_detail": "Detalle de los solicitantes",
  "applicants_details": "Detalles de los solicitantes",
  "application_form_fee": "Formulario de solicitud Tasa",
  "application_ref": "Referencia de aplicación",
  "application_status": "Estado de la solicitud",
  "april": "Abril",
  "are_you_employed": "Tiene usted un empleo?",
  "are_you_sure_you_want_to_delete_these_records": "Está seguro de que quiere eliminar estos registros?",
  "are_you_sure_you_want_to_delete_this_record": "Está seguro de que quiere eliminar este registro?",
  "athletics": "Atletismo",
  "attended_shs": "Asistentes SHS",
  "audit_for_applicants": "Auditoría para los solicitantes",
  "audit_for_applicants_details": "Detalles de la auditoría para los solicitantes",
  "august": "Agosto",
  "available": "Disponible",
  "awaiting_results": "A la espera de los resultados?",
  "baccalaureate": "BACALAUREATE",
  "back": "Volver",
  "badminton": "Bádminton",
  "baseball": "Béisbol",

  "basketball": "Baloncesto",
  "browse": "Buscar en...",
  "business": "Negocios",
  "campus_description": "Descripción del campus",
  "campus_name": "Nombre del campus",
  "cancel": "Cancelar",
  "capital_letter": "Letra mayúscula",
  "caps_institution_id": "CAPS Identificación de la institución",
  "caps_institutions_list": "Lista de instituciones CAPS",
  "caps_institutions_list_detail": "Detalle de la Lista de Instituciones de Caps",
  "caps_institutions_list_details": "Detalles de la Lista de Instituciones de Caps",
  "caps_mall_status": "Estado del centro comercial Caps",
  "caps_programme_id": "Programas CAPS ID",
  "caps_programmes_list": "Lista de programas CAPS",
  "caps_programmes_list_detail": "Detalle de la lista de programas CAPS",
  "caps_programmes_list_details": "Detalles de la lista de programas Caps",
  "certificate_url": "Url del certificado",
  "change_email": "Cambiar el correo electrónico",
  "change_password": "Cambiar la contraseña",
  "characters_minimum": "Caracteres mínimos",
  "checking_availability": " Comprobar la disponibilidad...",
  "chess": "Ajedrez",
  "choose_files_or_drop_files_here": "Elija el archivo o deje caer el archivo aquí",
  "click_here_to_login": "Haga clic aquí para iniciar sesión",
  "client_request_id": "ID. de solicitud del cliente",
  "close": "Cerrar",
  "completed": "Completado",
  "confirm_new_password": "Confirmar la nueva contraseña",
  "confirm_password": "Confirmar contraseña",
  "congratulations": "¡Enhorabuena!",
  "contact_us": "Contacto con nosotros",
  "continue": "continuar",
  "country": "País",
  "country_of_origin": "País de origen",
  "cricket": "Grillo",
  "cross_country": "Campo a través",
  "current_password": "Contraseña actual",
  "cut_off_point": "Punto de corte",
  "data_imported_successfully": "Datos importados con éxito",
  "date_created": "Fecha de creación",
  "date_updated": "Fecha de actualización",
  "day_of_birth": "Día de nacimiento",
  "deceased": "Fallecido",

  "december": "Diciembre",
  "degree_awarded": "Título otorgado",
  "degree_class": "Clase de grado",
  "delete": "Borrar",
  "delete_account": "Borrar la cuenta",
  "delete_record": "Borrar registro",
  "delete_selected": "Borrar lo seleccionado",
  "delete_this_record": "Eliminar este registro",
  "description": "Descripción",
  "dial_code": "Código de marcación",
  "did_you_attend_senior_high_school": "Asistió a la escuela secundaria superior?",
  "digital_address": "Dirección digital",
  "disability": "Discapacidad",
  "disability_other": "Discapacidad Otros",
  "distinction": "Distinción",
  "divorced": "Divorciado",
  "do_you_do_any_sports": "Haces algún deporte?",
  "do_you_have_any_disability": "Tiene alguna discapacidad?",
  "dob_day": "Día Dob",
  "dob_month": "Mes de Dob",
  "dob_year": "Año Dob",
  "dont_have_an_account": "No tiene una cuenta?",
  "drivers_license": "Licencia de conducir",
  "edit": "Editar",
  "edit__tabledisplaylabel": "Editar {Etiqueta de visualización de la tabla}",
  "edit_account": "Editar cuenta",
  "edit_administrators": "Editar administradores",
  "edit_app_config": "Editar la configuración de la aplicación",
  "edit_applicant_selected_grants": "Editar las subvenciones seleccionadas por el solicitante",
  "edit_applicants": "Editar solicitantes",
  "edit_caps_institutions_list": "Editar la Lista de Instituciones de Caps",
  "edit_caps_programmes_list": "Editar la lista de programas CAPS",
  "edit_institution_accounts": "Editar las cuentas de la institución",
  "edit_institution_admissions_uploads": "Editar las cargas de admisión de la institución",
  "edit_institution_campuses": "Edit Institution Campuses",

  "edit_institution_programmes": "Editar los programas de la institución",
  "edit_institution_schools": "Editar las escuelas de la institución",
  "edit_my_account": "Editar mi cuenta",
  "edit_payments": "Editar pagos",
  "edit_third_party_agencies": "Editar agencias de terceros",
  "edit_third_party_agencies_grants": "Editar las subvenciones de las agencias de terceros",
  "edit_this_record": "Editar este registro",
  "email": "Correo electrónico",
  "email_address": "Dirección de correo electrónico",
  "email_address_changed_successfully": "Dirección de correo electrónico cambiada con éxito",
  "email_address_is_already_verified": "La dirección de correo electrónico ya está verificada",
  "email_address_is_not_registered": "La dirección de correo electrónico no está registrada",
  "email_not_changed": "Correo electrónico no cambiado",
  "email_or_phone_number": "Correo electrónico o número de teléfono",
  "email_verification_completed": "Verificación de correo electrónico completada.",
  "email_verification_has_been_resent": "La verificación del correo electrónico ha sido reenviada",
  "email_verification_link_sent": "Envío del enlace de verificación por correo electrónico",
  "email_verified_at": "Correo electrónico verificado en",
  "employment_address": "Dirección de empleo",
  "employment_nature": "Naturaleza del empleo",
  "employment_nature_other": "Empleo Naturaleza Otros",
  "enter__fielddisplaylabel": "Introduzca {Etiqueta de visualización de campo}",
  "enter_account_email": "Introduzca el correo electrónico de la cuenta",
  "enter_account_name": "Introduzca el nombre de la cuenta",
  "enter_account_password": "Introduzca la contraseña de la cuenta",
  "enter_account_status": "Introducir el estado de la cuenta",
  "enter_account_type": "Introduzca el tipo de cuenta",
  "enter_account_username": "Introduzca el nombre de usuario de la cuenta",
  "enter_additional_form_definition": "Introduzca la definición del formulario adicional",
  "enter_address_line_3": "Introduzca la dirección de la línea 3",
  "enter_address_line1": "Introduzca la dirección de la línea1",
  "enter_address_line2": "Introduzca la dirección de la línea2",
  "enter_address_line3": "Introduzca la dirección de la línea3",
  "enter_address_line4": "Introduzca la dirección de la línea4",
  "enter_agency_name": "Introduzca el nombre de la agencia",
  "enter_allow_email_alert": "Introducir la alerta de correo electrónico",
  "enter_allow_sms_alert": "Introducir la alerta de sms",
  "enter_allow_two_factor_auth": "Introduzca Permitir la autenticación de dos factores",
  "enter_amount": "Ingrese el monto",
  "enter_applicant_accepted_programme_id": "Introduzca la identificación del programa aceptado por el solicitante",
  "enter_application_ref": "Introduzca la referencia de la solicitud",
  "enter_application_status": "Introducir el estado de la solicitud",
  "enter_attended_shs": "Ingresar SHS Asistidos",

  "enter_awaiting_results": "Entrar a la espera de resultados",
  "enter_campus_description": "Introduzca la descripción del campus",
  "enter_campus_name": "Introduzca el nombre del campus",
  "enter_certificate_url": "Introduzca la url del certificado",
  "enter_client_request_id": "Introduzca el ID de solicitud del cliente",
  "enter_country": "Introduzca el país",
  "enter_cut_off_point": "Introduzca el punto de corte",
  "enter_description": "Introduzca la descripción",
  "enter_dial_code": "Introduzca el código de marcación",
  "enter_did_you_attend_senior_high_school": "Ingresar Asistió a la escuela secundaria superior?",
  "enter_digital_address": "Introduzca la dirección digital",
  "enter_disability": "Ingresar a la Discapacidad",
  "enter_disability_other": "Introduzca la discapacidad Otros",
  "enter_dob_day": "Entrar en el día Dob",
  "enter_dob_month": "Introduzca el mes de Dob",
  "enter_dob_year": "Introduzca el año Dob",
  "enter_email": "Introduzca el correo electrónico",
  "enter_email_address": "Introduzca la dirección de correo electrónico",
  "enter_employment_address": "Introduzca la dirección de empleo",
  "enter_employment_nature": "Introduzca la naturaleza del empleo",
  "enter_employment_nature_other": "Introduzca la naturaleza del empleo Otros",
  "enter_entry_level": "Entrar en el nivel de entrada",
  "enter_entry_level_scenario": "Entrar en el escenario del nivel de entrada",
  "enter_exams_sittings": "Entrar en las sesiones de los exámenes",
  "enter_fathers_email": "Introduzca el correo electrónico del padre",
  "enter_fathers_living_status": "Introduzca el estado de vida del padre",
  "enter_fathers_name": "Introduzca el nombre del padre",
  "enter_fathers_occupation": "Introduzca la profesión del padre",
  "enter_fathers_occupation_other": "Introduzca la ocupación del padre Otra",
  "enter_fathers_telephone": "Introduzca el teléfono del padre",
  "enter_first_institution_acceptance": "Introduzca la primera aceptación de la institución",
  "enter_first_institution_first_programme_admission_status": "Introduzca la primera institución Estado de admisión al primer programa",
  "enter_first_institution_first_programme_id": "Introducir la primera institución Primera identificación del programa",
  "enter_first_institution_first_programme_options": "Entrar en la primera institución Opciones del programa",
  "enter_first_institution_first_programme_required_electives": "Ingresar a la primera institución Primer programa Electivos requeridos",
  "enter_first_institution_first_programme_session": "Entrar en la primera institución Primera sesión del programa",
  "enter_first_institution_id": "Introduzca la primera identificación de la institución",
  "enter_first_institution_second_programme_admission_status": "Introduzca la primera institución Segundo programa Estado de admisión",
  "enter_first_institution_second_programme_id": "Introduzca la primera institución y la segunda identificación del programa",
  "enter_first_institution_second_programme_options": "Introduzca la primera institución Segunda opción del programa",
  "enter_first_institution_second_programme_required_electives": "Entrar en la Primera Institución Segundo Programa Asignaturas optativas obligatorias",
  "enter_first_institution_second_programme_session": "Entrar en la primera institución Segunda sesión del programa",
  "enter_first_institution_third_programme_admission_status": "Introducir el estado de admisión de la primera institución del tercer programa",
  "enter_first_institution_third_programme_id": "Ingrese la primera institución la tercera identificación del programa",
  "enter_first_institution_third_programme_options": "Entrar en la Primera Institución Terceras Opciones del Programa",
  "enter_first_institution_third_programme_required_electives": "Entrar en la Primera Institución Tercer Programa Electivo Requerido",
  "enter_first_institution_third_programme_session": "Entrar en la primera institución Tercera sesión del programa",
  "enter_first_programme_options": "Introducir las primeras opciones del programa",
  "enter_firstname": "Introduzca el nombre",
  "enter_gender": "Introduzca el género",

  "enter_grant_additional_info": "Introduzca la información adicional de la subvención",
  "enter_grant_description": "Introduzca la descripción de la subvención",
  "enter_grant_name": "Introduzca el nombre de la subvención",
  "enter_grant_type": "Introduzca el tipo de subvención",
  "enter_guardian_address1": "Introduzca la dirección del tutor1",
  "enter_guardian_address2": "Introduzca la dirección del tutor2",
  "enter_guardian_address3": "Introduzca la dirección del tutor3",
  "enter_guardian_email": "Introduzca el correo electrónico del tutor",
  "enter_guardian_name": "Introduzca el nombre del tutor",
  "enter_guardian_occupation": "Introduzca la profesión de guardián",
  "enter_guardian_occupation_other": "Introduzca la ocupación del tutor Otros",
  "enter_guardian_telephone": "Introduzca el teléfono del tutor",
  "enter_has_attended_tertiary": "Entrar Ha asistido a Terciario",
  "enter_has_vacancy": "Entrar tiene una vacante",
  "enter_have_you_attended_any_tertiary_institution": "Introduzca Ha asistido a alguna institución terciaria?",
  "enter_hometown": "Introduzca su ciudad natal",
  "enter_hometown_region": "Introduzca la región de su ciudad natal",
  "enter_id_number": "Introduzca el número de identificación",
  "enter_in_case_you_are_not_offered_admission_would_you_like_the_selected_institution_to_pass_details_of_your_application_to_affiliated_private_universities": "Introduzca En caso de que no se le ofrezca la admisión, le gustaría que la institución seleccionada pasara los detalles de su solicitud a las otras universidades privadas?",
  "enter_in_case_you_dont_meet_the_regular_cut_off_point_would_you_like_to_be_considered_for_fee_paying": "Entre En caso de que no cumpla con el punto de corte regular, le gustaría ser considerado para el pago de honorarios?",
  "enter_index_number": "Enter Index Number",
  "enter_institution_additional_info": "Introduzca la información adicional de la institución",
  "enter_institution_school_id": "Introduzca la identificación de la escuela de la institución",
  "enter_is_athlete": "Introduzca es atleta",
  "enter_is_awaiting_results": "Enter está a la espera de los resultados",
  "enter_is_disable": "Introducir es deshabilitar",
  "enter_is_employed": "Enter es empleado",
  "enter_is_fee_paying": "Entrar es de pago",
  "enter_is_grant_available": "Entre es subvención disponible",
  "enter_last_competition": "Entrar en el último concurso",
  "enter_last_shs_attended": "Ingrese los últimos SHS Asistidos",
  "enter_last_shs_other": "Ingrese los últimos SHS Otros",
  "enter_last_shs_outside": "Introduzca el último SHS fuera",
  "enter_last_tertiary_attended": "Introduzca el último centro de enseñanza superior al que ha asistido",
  "enter_lastname": "Introduzca el apellido",
  "enter_marital_status": "Introduzca el estado civil",
  "enter_mothers_email": "Introduzca el correo electrónico de la madre",
  "enter_mothers_living_status": "Introduzca el estado de vida de la madre",
  "enter_mothers_name": "Introduzca el nombre de la madre",
  "enter_mothers_occupation": "Introduzca la profesión de la madre",
  "enter_mothers_occupation_other": "Introduzca la ocupación de la madre Otra",
  "enter_mothers_telephone": "Introduzca el teléfono de la madre",
  "enter_name": "Introduzca el nombre",
  "enter_national_id_number": "Introduzca el número de identificación nacional",
  "enter_national_id_type": "Introduzca el tipo de documento nacional de identidad",
  "enter_othernames": "Introducir otros nombres",
  "enter_otp": "Introduzca la OTP",

  "enter_pass_to_affiliate": "Ingrese el Pase al Afiliado",
  "enter_password": "Introduzca la contraseña",
  "enter_payment_status": "Introducir el estado del pago",
  "enter_ph_address_line1": "Introduzca la dirección Ph Línea1",
  "enter_ph_address_line2": "Introduzca la dirección Ph Línea2",
  "enter_ph_address_line3": "Introduzca la dirección Ph Línea3",
  "enter_ph_address_line4": "Introduzca la dirección Ph Línea4",
  "enter_primary_telephone": "Introduzca el teléfono principal",
  "enter_programme_description": "Introduzca la descripción del programa",
  "enter_programme_options": "Introduzca las opciones del programa",
  "enter_programme_required_electives": "Ingresar Programa Electivo Requerido",
  "enter_programme_title": "Introduzca el título del programa",
  "enter_religious_denomination": "Introduzca la denominación religiosa",
  "enter_religious_denomination_other": "Ingrese la denominación religiosa Otra",
  "enter_same_address_as_ph_address": "Introduzca la misma dirección que la de Ph",
  "enter_same_as_address_above": "Introduzca la misma dirección que la anterior",
  "enter_same_as_personal_information": "Introduzca lo mismo que la información personal",
  "enter_same_as_personal_information_above": "Introduzca lo mismo que los datos personales anteriores",
  "enter_same_bio_as_sponsor": "Introduzca la misma biografía que el patrocinador",
  "enter_scanned_national_id_card": "Introducir el DNI escaneado",
  "enter_second_institution_acceptance": "Introduzca la aceptación de la segunda institución",
  "enter_second_institution_first_programme_admission_status": "Introduzca el estado de admisión del primer programa de la segunda institución",
  "enter_second_institution_first_programme_id": "Introduzca la segunda institución y la primera identificación del programa",
  "enter_second_institution_first_programme_options": "Ingresar a la segunda institución Opciones del primer programa",
  "enter_second_institution_first_programme_required_electives": "Ingresar a la segunda institución Primer programa Optativas requeridas",
  "enter_second_institution_first_programme_session": "Entrar en la segunda institución Primera sesión del programa",
  "enter_second_institution_id": "Introduzca la segunda identificación de la institución",
  "enter_second_institution_second_programme_admission_status": "Enter Second Institution Second Programme Admission Status",
  "enter_second_institution_second_programme_id": "Introduzca la segunda institución Segunda identificación del programa",
  "enter_second_institution_second_programme_options": "Entrar en la segunda institución Opciones del segundo programa",
  "enter_second_institution_second_programme_required_electives": "Ingresar a la segunda institución Segundo programa Optativas requeridas",
  "enter_second_institution_second_programme_session": "Entrar en la segunda institución Segunda sesión del programa",
  "enter_second_institution_third_programme_admission_status": "Introducir el estado de admisión de la segunda institución del tercer programa",
  "enter_second_institution_third_programme_id": "Introducir la segunda institución Tercera identificación del programa",
  "enter_second_institution_third_programme_options": "Ingresar Segunda Institución Terceras Opciones del Programa",
  "enter_second_institution_third_programme_required_electives": "Ingresar a la Segunda Institución Tercer Programa Materias optativas requeridas",
  "enter_second_institution_third_programme_session": "Entrar en la segunda institución Tercera sesión del programa",
  "enter_second_programme_options": "Introduzca las opciones del segundo programa",
  "enter_shs_course": "Entrar en el curso de SHS",
  "enter_shs_exams_results": "Entrar en los resultados de los exámenes de SHS",
  "enter_shs_from_year": "Ingrese SHS del año",
  "enter_shs_grade": "Introduzca el grado de SHS",
  "enter_shs_qualification": "Introduzca la calificación de SHS",
  "enter_shs_to_year": "Ingrese SHS al año",
  "enter_sponsor_address": "Introduzca la dirección del patrocinador",
  "enter_sponsor_email": "Introduzca el correo electrónico del patrocinador",
  "enter_sponsor_name": "Introduzca el nombre del patrocinador",
  "enter_sponsor_telephone": "Introduzca el teléfono del patrocinador",
  "enter_sports_rep_institution": "Ingresar a la Institución de Representación Deportiva",
  "enter_street_address": "Introduzca la dirección de la calle",
  "enter_telephone": "Introduzca el teléfono",
  "enter_tertiary_degree_awarded": "Ingrese el título terciario otorgado",
  "enter_tertiary_degree_class": "Entrar en la clase de grado terciario",
  "enter_tertiary_from_year": "Ingresar al Terciario desde el año",
  "enter_tertiary_programme": "Entrar en el programa terciario",
  "enter_tertiary_reason_for_leaving": "Introduzca el motivo de abandono terciario",
  "enter_tertiary_student_id": "Introduzca la identificación del estudiante de educación superior",
  "enter_tertiary_to_year": "Entrar en Terciario Hasta el año",
  "enter_the_code": "Introduzca el código",
  "enter_third_institution_acceptance": "Introduzca el código",
  "enter_third_institution_first_programme_admission_status": "Introducir el estado de admisión del primer programa de la tercera institución",
  "enter_third_institution_first_programme_id": "Introducir la identificación del primer programa de la tercera institución",
  "enter_third_institution_first_programme_options": "Entrar en la tercera institución Opciones del primer programa",
  "enter_third_institution_first_programme_required_electives": "Ingresar a la Tercera Institución Primer Programa Electivo Requerido",
  "enter_third_institution_first_programme_session": "Entrar en la tercera institución Primera sesión del programa",
  "enter_third_institution_id": "Introduzca el ID de la tercera institución",
  "enter_third_institution_second_programme_admission_status": "Ingresar a la Tercera Institución Segundo Programa Estado de Admisión",
  "enter_third_institution_second_programme_id": "Introduzca la tercera institución Segunda identificación del programa",
  "enter_third_institution_second_programme_options": "Entrar en la tercera institución Segunda opción del programa",
  "enter_third_institution_second_programme_required_electives": "Ingresar en la tercera institución Segundo programa Asignaturas optativas obligatorias",
  "enter_third_institution_second_programme_session": "Entrar en la tercera institución Segunda sesión del programa",
  "enter_third_institution_third_programme_admission_status": "Ingresar a la Tercera Institución Estado de Admisión al Tercer Programa",
  "enter_third_institution_third_programme_id": "Introducir la tercera institución ID. del tercer programa",
  "enter_third_institution_third_programme_options": "Entrar en la tercera institución Opciones del tercer programa",
  "enter_third_institution_third_programme_required_electives": "Ingresar a la Tercera Institución Tercer Programa Electivo Requerido",
  "enter_third_institution_third_programme_session": "Entrar en la tercera institución Tercera sesión del programa",
  "enter_third_programme_options": "Introduzca las terceras opciones del programa",
  "enter_title": "Introduzca el título",

  "enter_transaction_id": "Introduzca la identificación de la transacción",
  "enter_txt_journey": "Entrar en el viaje de Txt",
  "enter_username": "Introduzca el nombre de usuario",
  "entry_level": "Nivel de entrada",
  "entry_level_scenario": "Escenario de nivel de entrada",
  "error_deleting_the_record__please_make_sure_that_the_record_exit": "Error al borrar el registro. Por favor, asegúrese de que la salida del registro",
  "error_inserting_record": "Error al insertar un registro",
  "error_processing_request": "¡Error al procesar la solicitud!",
  "error_registering_user": "Error al registrar el usuario",
  "error_sending_email__please_contact_system_administrator_for_more_info": "Error al enviar el correo electrónico. Por favor, póngase en contacto con el administrador del sistema para obtener más información",
  "error_uploading_file": "Error al cargar el archivo",
  "exams_sittings": "Sesiones de exámenes",
  "existing_qualification": "Calificación existente",
  "export": "Exportar",
  "export_csv": "Exportar CSV",
  "export_excel": "Exportar Excel",
  "export_page_fields": "Campos de la página de exportación",
  "export_word": "Exportación de Word",
  "fathers_email": "Correo electrónico del padre",
  "fathers_living_status": "Estado de vida del padre",
  "fathers_name": "Nombre del padre",
  "fathers_occupation": "Ocupación del padre",
  "fathers_occupation_other": "Ocupación del padre Otros",
  "fathers_telephone": "Teléfono del padre",
  "february": "Febrero",
  "female": "Mujer",
  "file_format_not_supported": "Formato de archivo no admitido",
  "first_choice_institution": "Institución de primera elección",
  "first_choice_programme": "Programa Primera Opción",
  "first_class": "Primera clase",
  "first_institution_acceptance": "Aceptación de la primera institución",
  "first_institution_first_programme_admission_status": "Primera Institución Primer Programa Estado de Admisión",
  "first_institution_first_programme_id": "Primera institución Primera identificación del programa",
  "first_institution_first_programme_options": "Primera institución Primeras opciones del programa",
  "first_institution_first_programme_required_electives": "Primera institución Primer programa Asignaturas optativas obligatorias",
  "first_institution_first_programme_session": "Primera institución Primera sesión del programa",
  "first_institution_id": "Primera Institución ID",
  "first_institution_second_programme_admission_status": "Primera Institución Segundo Programa Estado de Admisión",
  "first_institution_second_programme_id": "Primera institución Segunda identificación del programa",
  "first_institution_second_programme_options": "Primera institución Segunda opción del programa",
  "first_institution_second_programme_required_electives": "Primera institución Segundo programa Asignaturas optativas obligatorias",
  "first_institution_second_programme_session": "Primera institución Segunda sesión del programa",
  "first_institution_third_programme_admission_status": "Primera Institución Tercer Programa Estado de Admisión",
  "first_institution_third_programme_id": "Primera Institstución Tercero Programa ID",
  "first_institution_third_programme_options": "Primera Institución Terceras Opciones del Programa",
  "first_institution_third_programme_required_electives": "Primera Institución Tercer Programa Materias optativas obligatorias",
  "first_institution_third_programme_session": "Primera institución Tercera sesión del programa",
  "first_name": "Nombre",
  "first_programme_options": "Opciones del primer programa",
  "first_programme_session": "Primera sesión del programa",
  "firstname": "Nombre",
  "football": "Fútbol",
  "from": "Desde",
  "full_address_of_sponsor": "Dirección completa del patrocinador",
  "gender": "Género",
  "general_arts": "Artes generales",
  "ghana_card": "Tarjeta de Ghana",
  "goalball": "Bola de gol",
  "grant_additional_info": "Subvención Información adicional",
  "grant_description": "Descripción de la subvención",
  "grant_name": "Nombre de la subvención",
  "grant_type": "Tipo de subvención",
  "guardian_address1": "Dirección del tutor1",
  "guardian_address2": "Dirección del tutor2",
  "guardian_address3": "Dirección del tutor3",
  "guardian_email": "Correo electrónico de los guardianes",
  "guardian_name": "Nombre del tutor",
  "guardian_occupation": "Ocupación de los guardianes",
  "guardian_occupation_other": "Guardián Ocupación Otros",
  "guardian_telephone": "Teléfono guardián",
  "guardians_address_line_1": "Dirección del tutor Línea 1",
  "guardians_address_line_2": "Dirección del tutor Línea 2",
  "guardians_address_line_3": "Dirección del tutor Línea 3",
  "guardians_email": "Correo electrónico del tutor",
  "guardians_name": "Nombre del tutor",
  "guardians_occupation": "Ocupación del tutor",
  "guardians_telephone": "Teléfono del tutor",
  "handball": "Balonmano",
  "has_attended_tertiary": "Ha asistido a la educación terciaria",
  "has_vacancy": "Tiene una vacante",
  "have_you_attended_any_tertiary_institution": "Ha asistido a alguna institución terciaria?",
  "help_and_faq": "Ayuda y FAQ",
  "hi": "Hola",

  "hints___not_less_than_6_characters": "Pistas : No menos de 6 caracteres",
  "hockey": "El hockey",
  "home": "Inicio",
  "home_economics": "Economía doméstica",
  "home_town": "Ciudad de origen",
  "home_town_region": "Región de la ciudad natal",
  "hometown": "Ciudad natal",
  "hometown_region": "Región de origen",
  "import_data": "Importar datos",
  "in_case_you_are_not_offered_admission_would_you_like_the_selected_institution_to_pass_details_of_your_application_to_affiliated_private_universities": "En caso de que no se le ofrezca la admisión, desea que la institución seleccionada transmita los detalles de su solicitud a las otras universidades privadas?",
  "in_case_you_dont_meet_the_regular_cut_off_point_would_you_like_to_be_considered_for_fee_paying": "En caso de que no cumpla con el punto de corte regular, le gustaría ser considerado para el pago de tasas?",
  "index_number": "Número de índice",
  "institution_accounts": "Cuentas de la institución",
  "institution_accounts_details": "Detalles de las cuentas de la institución",
  "institution_additional_info": "Institución Información adicional",
  "institution_admissions_uploads": "Institución Admisiones Cargas",
  "institution_admissions_uploads_details": "Institución Admisiones Carga Detalles",
  "institution_campus_id": "Institución Campus ID",
  "institution_campuses": "Campus de la institución",
  "institution_campuses_detail": "Detalle de los campus de la institución",
  "institution_campuses_details": "Detalles de los campus de la institución",
  "institution_programme_id": "Institución ID de programa",
  "institution_programmes": "Programas institucionales",
  "institution_programmes_details": "Detalles de los programas de la institución",
  "institution_school_id": "Institución Escuela ID",
  "institution_schools": "Escuelas de la institución",
  "institution_schools_details": "Detalles de las escuelas de la institución",
  "invalid_captcha_code": "Código captcha inválido",
  "invalid_request": "Solicitud inválida",
  "is_athlete": "Es Atleta",
  "is_awaiting_results": "Está a la espera de los resultados",
  "is_disable": "Se desactiva",
  "is_employed": "Está empleada",
  "is_fee_paying": "Es de pago",
  "is_grant_available": "Está disponible la subvención?",
  "january": "Enero",
  "july": "Julio",
  "june": "Junio",
  "language": "Idioma",
  "last_competition": "Último concurso",
  "last_name": "Apellido (Apellidos)",
  "last_shs_attended": "Últimos SHS Asistidos",
  "last_shs_other": "Últimos SHS Otros",
  "last_shs_outside": "Últimos SHS en el exterior",
  "last_tertiary_attended": "Last Tertiary Attended",
  "lastname": "Apellido",
  "limit": "Límite",
  "load_more": "Load More",
  "loading": "Cargando...",
  "log_id": "ID. de registro",
  "login": "Inicio de sesión",
  "login_completed": "Inicio de sesión completado",
  "logout": "Cierre de sesión",
  "male": "Hombre",
  "march": "Marzo",
  "marital_status": "Estado civil",
  "married": "Casado",
  "may": "Mayo",
  "month_of_birth": "Mes de nacimiento",
  "mothers_email": "Correo electrónico de la madre",
  "mothers_living_status": "Estado de vida de la madre",
  "mothers_name": "Nombre de la madre",
  "mothers_occupation": "Ocupación de la madre",
  "mothers_occupation_other": "Ocupación de la madre Otros",
  "mothers_telephone": "Teléfono de la madre",
  "my_account": "Mi cuenta",
  "name": "Nombre",
  "name_and_address_of_employer": "Nombre y dirección del empleador",
  "name_of_sponsor": "Nombre del patrocinador",
  "national_id_number": "Número de identificación nacional",
  "national_id_type": "Tipo de identificación nacional",
  "nature_of_employment": "Naturaleza del empleo",
  "netball": "Baloncesto",
  "new_password": "Nueva contraseña",
  "new_values": "Nuevos valores",
  "no": "No ",
  "no_file_selected_for_upload": "No se ha seleccionado ningún archivo para cargar",
  "no_more_content_to_load": "No hay que cargar más contenido",
  "no_record_found": "No se ha encontrado ningún registro",
  "no_record_inserted": "No se ha insertado ningún registro",
  "no_record_updated": "Ningún registro actualizado",
  "not_available": "No disponible",
  "november": "Noviembre",
  "number": "Number",
  "o_level": "O-NIVEL",
  "october": "Octubre",
  "of": "de",
  "old_values": "Antiguos valores",
  "other": "Otros",
  "other_caps": "OTROS",
  "other_names": "Otros nombres (Nombres intermedios)",
  "othernames": "Otros nombres",
  "otp_has_been_sent_to_your_email": "La OTP ha sido enviada a su correo electrónico",
  "otp_has_been_sent_to_your_phone_number_via_sms": "La OTP ha sido enviada a su número de teléfono por SMS",
  "otp_verification": "Verificación OTP",
  "page": "Página",
  "pass": "Pass",
  "pass_to_affiliate": "Pase al afiliado",
  "passport": "Pasaporte",
  "passport_picture": "Foto del pasaporte",
  "password": "Contraseña",
  "password_reset": "Restablecimiento de la contraseña",
  "password_reset_key_failure": "Fallo de la clave de restablecimiento de la contraseña",
  "payment_id": "Identificación del pago",
  "payment_status": "Estado de los pagos",
  "payments": "Pagos",

  "payments_details": "Detalles de los pagos",
  "ph_address_line1": "Dirección Ph Línea1",
  "ph_address_line2": "Dirección Ph Línea2",
  "ph_address_line3": "Dirección Ph Línea3",
  "ph_address_line4": "Dirección Ph Línea4",
  "phone_number": "Número de teléfono",
  "photo": "Foto",
  "please_a_choose_file": "Por favor, elija un archivo",
  "please_contact_the_system_administrator_for_more_information": "Para más información, póngase en contacto con el administrador del sistema",
  "please_enter_text": "Por favor, introduzca el texto",
  "please_provide_the_valid_email_address_you_used_to_register": "Indique la dirección de correo electrónico válida que utilizó para registrarse",
  "please_verify_your_email_address_by_following_the_link_in_your_mailbox": "Por favor, verifique su dirección de correo electrónico siguiendo el enlace de su buzón",
  "please_you_can_try_reseting_your_password_by_following_these_steps": "Por favor, puedes intentar restablecer tu contraseña siguiendo estos pasos ",
  "primary_telephone": "Teléfono principal",
  "print": "Imprimir",
  "print___pdf": "Imprimir | PDF",
  "print_page_settings": "Configuración de la página de impresión",
  "privacy_policy": "Política de privacidad",
  "programme_description": "Descripción del programa",
  "programme_options": "Opciones del programa",
  "programme_required_electives": "Programa de asignaturas optativas obligatorias",
  "programme_title": "Título del programa",
  "provide_new_password": "Proporcionar una nueva contraseña",
  "record_added_successfully": "Registro añadido con éxito",
  "record_deleted_successfully": "Registro borrado con éxito",
  "record_id": "ID. de registro",
  "record_updated_successfully": "Registro actualizado con éxito",
  "records": "Registros",
  "register": "Registro",
  "religious_denomination": "Denominación religiosa",
  "religious_denomination_other": "Denominación religiosa Otros",
  "remember_me": "Recuérdame",
  "remove_page_links": "Eliminar los enlaces de la página",
  "request_url": "Solicitar Url",
  "resend_email": "Reenviar correo electrónico",
  "reset_password": "Restablecer contraseña",
  "rugby": "Rugby",
  "same_address_as_ph_address": "La misma dirección que la de Ph",
  "same_as_address_above": "Igual que la dirección anterior",
  "same_as_personal_information": "Igual que la información personal",
  "same_as_personal_information_above": "Igual que la información personal anterior",
  "same_bio_as_sponsor": "La misma biografía que el patrocinador",
  "save_png": "Guardar PNG",
  "saving": "Guardar...",
  "scanned_national_id_card": "Documento nacional de identidad escaneado",
  "science": "Ciencia",
  "search": "Buscar en",
  "second_choice_institution": "Institución de segunda elección",
  "second_choice_programme": "Programa de segunda opción",
  "second_class_lower": "Segunda clase inferior",
  "second_class_upper": "Segunda clase superior",
  "second_institution_acceptance": "Aceptación de la segunda institución",
  "second_institution_first_programme_admission_status": "Second Institution First Programme Admission Status",
  "second_institution_first_programme_id": "Segunda Institución Primer Programa ID",
  "second_institution_first_programme_options": "Segunda Institución Primer Programa Opciones",
  "second_institution_first_programme_required_electives": "Segunda Institución Primer Programa Asignaturas optativas obligatorias",
  "second_institution_first_programme_session": "Segunda Institución Primera Sesión del Programa",
  "second_institution_id": "Segunda Institución ID",
  "second_institution_second_programme_admission_status": "Segunda Institución Segundo Programa Estado de Admisión",
  "second_institution_second_programme_id": "Segunda institución Segunda identificación del programa",
  "second_institution_second_programme_options": "Segunda institución Opciones del segundo programa",
  "second_institution_second_programme_required_electives": "Segunda institución Segundo programa Asignaturas optativas obligatorias",
  "second_institution_second_programme_session": "Segunda Institución Segunda sesión del programa",
  "second_institution_third_programme_admission_status": "Segunda Institución Tercer Programa Estado de Admisión",
  "second_institution_third_programme_id": "Segunda institución Tercera identificación del programa",
  "second_institution_third_programme_options": "Segunda Institución Terceras Opciones del Programa",
  "second_institution_third_programme_required_electives": "Segunda Institución Tercer Programa Materias optativas obligatorias",
  "second_institution_third_programme_session": "Segunda institución Tercera sesión del programa",
  "second_programme_options": "Opciones del segundo programa",
  "second_programme_session": "Segunda sesión del programa",
  "select": "Seleccione ...",
  "select_a_file_to_import": "Seleccione un archivo para importar",
  "select_a_value": "Seleccione un valor ...",
  "select_first_choice_institution": "Seleccione la institución de primera elección ...",
  "select_first_choice_programme": "Seleccione el programa First Choice ...",
  "select_guardians_occupation": "Seleccione la ocupación del tutor ...",
  "select_paper_size": "Seleccione el tamaño del papel",
  "select_second_choice_institution": "Seleccione la institución de segunda elección ...",
  "select_second_choice_programme": "Seleccione el programa de segunda opción ...",
  "select_third_choice_institution": "Seleccione la institución de tercera elección ...",
  "select_third_choice_programme": "Seleccione el programa de tercera opción ...",
  "send": "Enviar",
  "separated": "Separado",
  "september": "Septiembre",
  "should_contain": "Debe contener",
  "show_header": "Mostrar cabecera",
  "shs__outside_ghana": "SHS (fuera de Ghana)",
  "shs_certificate": "Certificado SHS",
  "shs_course": "Curso SHS",
  "shs_exams_results": "Resultados de los exámenes de SHS",
  "shs_from_year": "SHS Del año",
  "shs_grade": "SHS Puntuación agregada",
  "shs_qualification": "SHS Calificación",
  "shs_to_year": "SHS Al año",
  "single": "Solo",
  "sort_by": "Ordenar por",
  "specify_disability": "Especifique la discapacidad",
  "specify_all_other_disability": "Especifique las demás discapacidades",
  "specify_discipline": "Especifique la disciplina",
  "specify_other": "Especificar otros",
  "specify_senior_high_school__outside_ghana": "Especificar escuela secundaria superior (fuera de Ghana)",
  "sponsor_address": "Dirección del patrocinador",
  "sponsor_email": "Correo electrónico del patrocinador",
  "sponsor_name": "Nombre del patrocinador",
  "sponsor_telephone": "Teléfono del patrocinador",
  "sports_rep_institution": "Institución de representación deportiva",
  "sssce": "SSSCE",
  "street_address": "Dirección de la calle",
  "student_id_number": "Número de identificación del estudiante",
  "submit": "Enviar",
  "supported_file_types": "Tipos de archivo admitidos",
  "swimming": "Natación",
  "symbol": "Símbolo",
  "table_tennis": "Tenis de mesa",
  "tabledisplaylabel__details": "{Etiqueta de visualización de la tabla} Detalles",
  "technical": "Técnica",
  "telephone": "Telephone",
  "terms_and_conditions": "Términos y condiciones",
  "tertiary_degree_awarded": "Título terciario otorgado",
  "tertiary_degree_class": "Clase de titulación terciaria",
  "tertiary_from_year": "Terciario Desde el año",
  "tertiary_programme": "Programa terciario",
  "tertiary_reason_for_leaving": "Motivo de abandono terciario",
  "tertiary_student_id": "ID. de estudiante terciario",
  "tertiary_to_year": "Terciario Al año",
  "the_dashboard": "El cuadro de mandos",
  "the_email_address_is_not_registered_on_the_system": "La dirección de correo electrónico no está registrada en el sistema",
  "the_email_verification_link_is_not_valid": "El enlace de verificación del correo electrónico no es válido",
  "third_choice_institution": "Institución de tercera elección",
  "third_choice_programme": "Programa de tercera opción",
  "third_class": "Tercera clase",
  "third_institution_acceptance": "Aceptación de la tercera institución",
  "third_institution_first_programme_admission_status": "Tercera Institución Primer Programa Estado de Admisión",
  "third_institution_first_programme_id": "Third Institution First Programme ID",
  "third_institution_first_programme_options": "Opciones del programa de la tercera institución",
  "third_institution_first_programme_required_electives": "Tercera Institución Primer Programa Asignaturas optativas obligatorias",
  "third_institution_first_programme_session": "Tercera Institución Primera sesión del programa",
  "third_institution_id": "Tercera Institución ID",
  "third_institution_second_programme_admission_status": "Tercera Institución Segundo Programa Estado de Admisión",
  "third_institution_second_programme_id": "Tercera institución Segunda identificación del programa",
  "third_institution_second_programme_options": "Tercera institución Segunda opción del programa",
  "third_institution_second_programme_required_electives": "Tercera Institución Segundo Programa Asignaturas optativas obligatorias",
  "third_institution_second_programme_session": "Tercera institución Segunda sesión del programa",
  "third_institution_third_programme_admission_status": "Tercera Institución Tercer Programa Estado de Admisión",
  "third_institution_third_programme_id": "Tercera institución Tercera identificación del programa",
  "third_institution_third_programme_options": "Tercera institución Opciones del tercer programa",
  "third_institution_third_programme_required_electives": "Tercera Institución Tercer Programa Asignaturas optativas obligatorias",
  "third_institution_third_programme_session": "Tercera institución Tercera sesión del programa",
  "third_party_agencies": "Agencias de terceros",
  "third_party_agencies_detail": "Detalle de las agencias de terceros",
  "third_party_agencies_details": "Detalles de las agencias de terceros",
  "third_party_agencies_grant_id": "Agencias de tercera parte ID. de subvención",
  "third_party_agencies_grants": "Subvenciones de organismos terceros",
  "third_party_agencies_grants_detail": "Subvenciones de organismos terceros Detalle",
  "third_party_agencies_grants_details": "Detalles de las subvenciones de las agencias de terceros",
  "third_party_agency_id": "ID. de agencia de terceros",
  "third_programme_options": "Opciones del tercer programa",
  "third_programme_session": "Tercera sesión del programa",
  "timestamp": "Marca de tiempo",
  "title": "Título",
  "to": "Para",
  "transaction_id": "Identificación de la transacción",
  "txt_journey": "Viaje Txt",
  "unable_to_complete_request": "No se puede completar la solicitud.",
  "update": "Actualización",
  "upload_a_copy_of_the_provided_national_id": "Suba una Foto del documento nacional de identidad proporcionado",
  "upload_passport_size_photograph": "Subir una fotografía tamaño pasaporte",
  "user_agent": "Agente del usuario",
  "user_id": "ID de usuario",
  "user_ip": "Ip del usuario",
  "user_login": "Inicio de sesión del usuario",
  "user_registration": "Registro de usuarios",
  "username": "Nombre de usuario",
  "username___email___phone_number": "Nombre de usuario / Correo electrónico / Número de teléfono",
  "username_or_email": "Nombre de usuario o correo electrónico",
  "username_or_password_not_correct": "El nombre de usuario o la contraseña no son correctos",
  "username_or_phone_number": "Nombre de usuario o número de teléfono",
  "verify": "Verificar",
  "view": "Ver",
  "view_record": "Ver el registro",
  "visual_arts": "Artes visuales",
  "vocational": "Vocacional",
  "volleyball": "Voleibol",
  "voters_id": "Identificación de los votantes",
  "wassce": "WASSCE",
  "welcome": "Bienvenido",
  "withdrawal": "Retirada",
  "would_you_like_to_represent_institution": "Le gustaría representar a la institución?",
  "year_of_birth": "Año de nacimiento",
  "yes": "Sí",
  "your_account_has_been_blocked": "Su cuenta ha sido bloqueada",
  "your_account_has_been_created": "Su cuenta ha sido creada.",
  "your_account_is_not_active__please_contact_system_administrator_for_more_information": "Su cuenta no está activa. Por favor, póngase en contacto con el administrador del sistema para obtener más información",
  "your_account_is_waiting_for_review": "Su cuenta está a la espera de ser revisada",

  "your_password_confirmation_is_not_consistent": "La confirmación de su contraseña no es consistente",
  "your_password_has_been_changed_successfully": "Su contraseña ha sido cambiada con éxito",
  "your_password_has_expired__please_reset_your_password_to_continue": "Su contraseña ha caducado. Por favor, restablezca su contraseña para continuar.",
  "your_password_reset_was_not_completed": "El restablecimiento de la contraseña no se ha completado",

  "welcome_to_caps_for_students": "Bienvenido al CAPS",
  "create_an_account": "Crear una cuenta",
  "at_least_one_lowercase": "Al menos una minúscula",
  "at_least_one_uppercase": "Al menos una mayúscula",
  "at_least_one_numeric_value": "Al menos un valor numérico",
  "minimum_8_characters": "Mínimo 8 caracteres",
  "suggestions": "Sugerencias",
  "create_your_new_password": "Cree su nueva contraseña",
  "all_fields_are_required": "Todos los campos son obligatorios",
  "all_rights_reserved": "Todos los derechos reservados",
  "application_results": "Resultados de la aplicación",
  "caps_mall": "Centro comercial CAPS",
  "help_and_support": "Ayuda y asistencia",
  "your_dashboard": "Su panel de control",
  "application_form": "Formulario de solicitud",
  "bio_information": "Información biográfica",
  "family_information": "Información sobre la familia",
  "academic_history": "Historia académica",
  "programme_selections": "Selección de programas",
  "funding_or_scholarship": "Financiación/Becas",
  "payment": "Pago",
  "pending": "Pendiente",
  "completed": "Completado",
  "welcome_to_caps": "Bienvenido a CAPS",
  "click_button_to_load_applcaition_form": "Su formulario de solicitud está listo. Solicite 3 universidades con una sola compra. Haga clic en el botón para abrir el formulario de solicitud",
  "open_application_form": "Formulario de solicitud abierto",
  "important_notice": "Aviso importante",
  "academic_year": "Año académico",
  "form_fees": "Formulario de tasas",
  "deadline_for_submission": "Fecha límite de presentación",
  "application_status_overview": "Resumen del estado de la aplicación",
  "your_selections": "Sus selecciones",
  "save_and_continue": "Guardar y continuar",
  "date_of_birth": "Fecha de nacimiento",
  "day": "Día",
  "month": "Mes",
  "year": "Año",

  "personal_information": "Información personal",
  "primary_contact": "Contacto principal",
  "please_provide_a_valid_phone_number": "Indique un número de teléfono válido. Este será su número de contacto principal para CAPS.",
  "address_of_applicant": "Dirección del solicitante",
  "sponsors_details": "Datos del patrocinador",
  "guardian_parent_next_of_kin_information": "Información sobre el tutor / padre / pariente más cercano",
  "sports_information": "Información deportiva",
  "you_can_select_multiple_disciplines": "Puede seleccionar varias disciplinas",
  "disability_special_needs_information": "Discapacidad (información sobre necesidades especiales)",
  "employment_information": "Información sobre el empleo",
  "identification": "Identificación",
  "upload_passport_size_photograph": "Subir una fotografía tamaño pasaporte",
  "the_maximum_size_of_your_provided_national_id_must_not_be_more_than_3MB": "El tamaño máximo de su documento nacional de identidad proporcionado no debe ser superior a 3 MB. Formatos de archivo admitidos: ",
  "click_here_to_view_uploaded_document": "Haga clic aquí para ver el documento cargado",
  "image_preview": "Vista previa de la imagen",
  "fathers_information": "Información del padre",
  "mothers_information": "Información de la madre",
  "tertiary_institution_information": "Información sobre la institución terciaria",
  "shs_information": "Información de SHS",
  "country_or_location": "País o ubicación",
  "in_ghana": "En Ghana",
  "outside_ghana": "Fuera de Ghana",
  "exams_sitting": "Exámenes Sentados",
  "entry_information": "Información de entrada",
  "exams_type": "Tipo de exámenes",
  "first_institution": "Primera Institución",
  "second_institution": "Segunda Institución",
  "third_institution": "Tercera Institución",
  "first_choice_institution": "Institución de primera elección",
  "second_choice_institution": "Institución de segunda elección",
  "third_choice_institution": "Institución de tercera elección",
  "select_first_choice_programme": "Seleccione el programa First Choice",
  "select_second_choice_programme": "Seleccione el programa de segunda opción",
  "select_third_choice_programme": "Seleccione el programa de tercera opción",
  "for_courier_services": "Para servicios de mensajería",
  "permanent_home_address": "Domicilio permanente",
  "specify_senior_high_school_outside_ghana": "Especificar escuela secundaria superior (fuera de Ghana)",
  "shs_outside_ghana": "SHS (fuera de Ghana)",
  "confirm_index_number": "Confirmar número de índice",
  "specify_tertiary_outside_ghana": "Especifique la institución terciaria (fuera de Ghana)",
  "tertiary_outside_ghana": "Terciario (fuera de Ghana)",
  "apply_now": "Solicite ahora",

  "hearing_impairment": "Discapacidad auditiva",
  "hearing_impaired": "Discapacidad auditiva",
  "deaf": "Sordo",
  "mobility_physical_impairment": "Deterioro de la movilidad (física)",
  "physically_handicapped": "Discapacitados físicos",
  "wheelchair_bound": "En silla de ruedas",
  "lame_in_crutches": "Cojo (en muletas)",
  "lame_on_crutches": "Cojo (con muletas)",
  "speech_or_language_impairment": "Deterioro del habla o del lenguaje",
  "speech_impaired": "Discapacidades del habla",
  "visual_impairment": "Discapacidad visual",
  "blind": "A ciegas",
  "partially_sighted": "Vidente parcial",
  "other_impairment": "Otros deterioros",
  "help_item_1": "Qué es Caps?",
  "help_item_1_description": "El Sistema Centralizado de Tramitación de Solicitudes (CAPS) es un sistema centralizado que cuenta con todas las universidades para facilitar y hacer más asequible a los solicitantes la solicitud de ingreso en las escuelas de su elección..",
  "help_item_2": "Qué es el centro comercial Caps?",
  "help_item_2_description": "Caps Mall da la oportunidad a los solicitantes que han perdido la oportunidad de ser admitidos en las escuelas preferidas debido a cuestiones de grado, no hay vacantes para los programas o cursos elegidos y también los solicitantes de grado por debajo del punto de corte.",
  "help_item_3": "A cuántas escuelas puedo presentarme?",
  "help_item_3_description": "Los solicitantes pueden presentarse a tres escuelas.",
  "help_item_4": "Cómo sé que he sido admitido en una determinada universidad?",
  "help_item_4_description": "Se enviará un correo electrónico al solicitante. Se aconseja que los solicitantes utilicen direcciones de correo electrónico válidas al rellenar los formularios.",
  "help_item_5": "Qué debo hacer si no puedo superar la fase de revisión de la solicitud?",
  "help_item_5_description": "Por favor, revise su solicitud y rellene los campos obligatorios que no están rellenados.",
  "help_item_6": "Cómo puedo ponerme en contacto con una universidad en la que he presentado una solicitud?",
  "help_item_6_description": "Ir a la página web de la universidad para obtener información de contacto",
  "help_item_7": "Cuáles son los requisitos de acceso?",
  "help_item_7_description": "Los requisitos de admisión son los resultados del wassce, los resultados del ssce con un grado mínimo de c6. También los solicitantes con certificado adquirido en otras calificaciones pueden aplicar.",

  "programme": "Programa",
  "cut_off_point": "Punto de corte",
  "no_record_found": "No se ha encontrado ningún registro",
  "accept_offer": "Aceptar la oferta",
  "status": "Estatus",
  "all_fields_marked_are_mandatory": "Todos los campos marcados con * son obligatorios",
  "names_provided_should_be_as_seen_on_your_national_id": "Los nombres proporcionados deben ser los que aparecen en su DNI",
  "all_telephone_numbers_must_start_with_the_country_code": "Todos los números de teléfono deben comenzar con el código de país + el número de marcado",
  "instructions": "Instrucciones",

  "campus": "El campus",
  "select_campus": "Seleccione el campus (opcional)",
  "programme_sessions": "Sesiones del programa",
  "select_programme_session": "Seleccione la sesión del programa (opcional)",
  "duplicate_institution_selection_found": "Se ha encontrado una selección de instituciones duplicada. Por favor, compruebe sus selecciones",
  "duplicate_programme_selection_found": "Se ha encontrado una selección de programa duplicada. Por favor, compruebe sus selecciones",
  "information_was_updated": "La información fue actualizada",
  "form_saved_successfully": "Formulario guardado con éxito",
  "please_complete_the_form": "Por favor, rellene el formulario",
  "form_is_invalid": "El formulario no es válido",
  "undertaking": "Emprendiendo",
  "apply_for_funding_or_scholarship": "Solicitar un préstamo, una financiación o una beca para solicitantes",
  "add_new_grant": "Añadir nueva subvención",
  "you_can_add_up_to_4_exams_sittings": "Puede añadir hasta 4 sesiones de examen. Haga clic en el icono + en la parte inferior de esta sección para añadir más campos de entrada",
  "click_on_icon_at_the_bottom_to_add_more": "Haga clic en el icono + en la parte inferior de esta sección para cargar el formulario",
  "third_party_agency": "Agencia de terceros",
  "add_new_item": "Añadir nuevo elemento",
  "click_here_for_more_information": "Haga clic aquí para obtener más información",
  "kindly_provide_additional_information_for_selected_item": "Por favor, proporcione información adicional para el artículo seleccionado",
  "add_more": "Añadir más",
  "add_new": "Añadir nuevo",
  "modify": "Modificar",
  "remove": "Eliminar",
  "are_you_sure_you_want_to_remove_this_item_from_your_list": "Está seguro de que quiere eliminar este artículo de su lista?",
  "confirm_action": "Confirmar la acción",
  "no_additional_fields_found": "No se han encontrado campos adicionales para modificar",
  "item_removed_successfully": "Artículo eliminado con éxito",
  "review_and_submit": "Revisar y enviar",
  "submit_application": "Presentar la solicitud",
  "you_will_not_be_able_make_any_changes_after_submission": "No podrá hacer ningún cambio después del envío",
  "submit_application_for_review": "Presentar la solicitud para su revisión",
  "applicant": "Solicitante",
  "application_has_been_submitted_successfully": "La solicitud ha sido presentada con éxito",
  "confirmation": "Confirmación",
  "are_you_sure_you_want_to_submit_this_application": "Está seguro de que desea presentar esta solicitud? No podrá hacer ningún cambio después de enviarla",
  "application_form_fee_is_only": "La tasa de solicitud es sólo",
  "select_any_of_the_payment_methods_available_and_provide_required_information": "Seleccione cualquiera de los métodos de pago disponibles y proporcione la información requerida.",
  "telephone_wallet_number": "Número de teléfono/monedero",
  "payment_method": "Forma de pago",
  "card_number": "Número de tarjeta",
  "card_holder_name": "Nombre del titular",
  "cvv": "Cvv",
  "expiry_month": "Mes de caducidad",
  "expiry_year": "Año de expiración",
  "payment_was_successful": "El pago fue exitoso",
  "proceed": "Proceder",
  "awaiting_payment_authorization_and_confirmation": "A la espera de la autorización y confirmación del pago...",
  "payment_authorization_request_sent": "Solicitud de autorización de pago enviada...!",
  "to_complete_payment_you_will_receive_a_prompt_on_your_mobile_device": "Para completar el pago: Recibirás un aviso en tu dispositivo móvil. Introduzca el PIN de su monedero para confirmar el pago.",
  "filter_by_institution": "Filtrar por institución",
  "filter_by_programme": "Filtrar por programa",
  "filter_by_cut_off_aggregate": "Filtro por corte de agregado",
  "applied": "Aplicado",
  "application_form_created": "Formulario de solicitud creado",
  "application_submitted": "Solicitud presentada",
  "required_electives": "Optativas requeridas",
  "select_programme_options": "Seleccione la(s) opción(es) del programa",
  "telephone_wallet_number_must_be_ten_digit": "Si utiliza el método de pago de la cartera móvil, asegúrese de proporcionar un número de cartera móvil válido.",
  "you_have_not_completed_your_application_form": "No ha completado su formulario de solicitud. Para ver los resultados de su solicitud, por favor, rellene la solicitud",
  "caps_mall_is_temporarily_closed": "El centro comercial CAPS está cerrado temporalmente",
  "please_come_back_later": "Por favor, vuelva más tarde. Gracias",
  "are_you_sure_you_want_to_accept_this_offer": "Está seguro de que quiere aceptar esta oferta? No podrá cambiar su elección después de esto.",
  "by_clicking_yes_you_confirm_your_caps_application_programme_choice_as": "Al hacer clic en 'Sí', confirma su elección del programa de aplicación CAPS como",
  "website": "Página web",
  "location": "Ubicación",
  "cut_off_point": "Punto límite",
  "available_sessions": "Sesiones disponibles",
  "programme_campuses": "Campus del programa",
  "affiliated_institution": "Institución afiliada",
  "website_url": "Url de la web",
  "address": "Dirección",
  "scenario": "Escenario",
  "programme_name": "Nombre del programa",
  "institution_name": "Nombre de la institución",
  "download_letter": "Descargar carta",
  "i_have_paid": "He pagado",
  "application_summary": "Resumen de la aplicación",
  "must_start_with_the_country_code": "Debe comenzar con el código de país + número de marcado. Ex: 233209013836",
  "click_here_to_provide_application_form_data": "Es necesario proporcionar más información en el sitio web del fondo/beca para completar la solicitud. Haga clic aquí para continuar",
  "minimum_requirements_for_admission_to_tertiary": "Requisitos mínimos para la admisión en instituciones de educación terciaria en Ghana",
  "Further_to_earlier_notices_issued_phrase": "A raíz de los avisos anteriores emitidos por el Consejo Nacional de Acreditación (NAB) sobre lo anterior, y en consulta con las partes interesadas pertinentes, los organismos reguladores de la educación terciaria desean reafirmar los requisitos mínimos aceptables de entrada para la admisión en las diversas instituciones de educación terciaria.",
  "minimum_entry_requirements": "Requisitos mínimos de acceso",
  "export_letter": "Carta de exportación",
  "payment_failed_auto_refund_initiated_please_check_funds": "Pago fallido. Reembolso automático iniciado. Por favor, compruebe los fondos en la cuenta o puede esperar 5 minutos e intentarlo de nuevo",
  "please_verify_first_time_use_of_card_with_amount_deducted_from_bank_account": "Por favor, verifique el primer uso de la tarjeta con el importe deducido de la cuenta bancaria. Verifique el primer uso de la tarjeta con el importe deducido de la cuenta bancaria",
  "an_amount_of_money_has_been_deducted_from_your_bank_account": "Se ha deducido una cantidad de dinero de su cuenta bancaria. Por favor, introduzca la cantidad exacta en el espacio siguiente",
  "card_will_be_blocked_after_3_failed_verification_attempts": "NOTA: La tarjeta se bloqueará después de 3 intentos fallidos de verificación",
  "fathers_firstname": "Nombre del padre",
  "fathers_lastname": "Apellido del padre (Apellidos)",
  "mothers_firstname": "Nombre de la madre",
  "mothers_lastname": "Apellido de la madre (Apellidos)",
  "guardians_firstname": "Nombre del tutor",
  "guardians_lastname": "Apellido del tutor (Apellidos)",
  "success": "Éxito",
  "kindly_reload_page_if_dropdown_not_showing": "Por favor, recargue la página si la lista desplegable no se rellena",
  "tertiary_name_outside": "Nombre terciario (fuera de Ghana)",
  "wassce_for_school_candidates": "WASSCE para candidatos escolares. Escrito por primera vez en 2006",
  "wassce_for_private_candidates": "WASSCE para candidatos privados. Escrito por primera vez en 2007",
  "ssce_for_school_candidates": "SSSCE para candidatos escolares. Escrito por primera vez en 1993 y finalizado en 2005",
  "ssce_for_private_candidates": "SSSCE para candidatos privados. Escrito por primera vez en 1993 y terminado en 2005",
  "advanced_business_certificate_examination": "Examen de Certificado Empresarial Avanzado (ABCE)",
  "general_business_certificate_examination": "Examen de Certificado General de Empresa (GBCE)",
  "verify_results": "Verificar Exámenes",
  "click_to_verify_your_sitting_details": "Haga clic en el botón 'Verificar los resultados de los exámenes' para verificar los datos de sus exámenes. Este mensaje desaparecerá cuando la verificación sea exitosa. Debe hacerlo para asegurarse de que la información presentada es correcta",
  "you_have_2_attempts_to_validate_ghana_card_number": "NOTA: Dispone de 2 intentos para validar el número de tarjeta de Ghana. Asegúrese de haber introducido el número de identificación correcto antes de hacer clic en el botón Validar. Su nombre aparecerá en los campos Nombre y Apellido cuando la verificación sea exitosa.",
  "type_of_certificate": "Type of Certificate",
  "upload_copy_of_certificate": "Upload a copy of your certificate",
  "certificate_id": "Certificate ID",
  "the_maximum_size_of_your_provided_national_id_must_not_be_more_than_10MB": "The maximum size of your provided national ID must not be more than 10MB. Supported file formats: ",
  "select_cohort": "Select Cohort",
  "cohort": "Cohort",
  "": "",
  "": "",
  "": "",
  "": "",
}